import { render, staticRenderFns } from "./AffiliateCommissions.vue?vue&type=template&id=05dc926e&scoped=true&"
import script from "./AffiliateCommissions.vue?vue&type=script&lang=js&"
export * from "./AffiliateCommissions.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateCommissions.vue?vue&type=style&index=0&id=05dc926e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dc926e",
  null
  
)

export default component.exports